/* eslint-disable jsx-a11y/tabindex-no-positive */
import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Label, Input } from "rbx";

import {
  BooleanInput,
  PhoneNumberInput,
  StateSelect,
  SystemCodeSelect,
  ZipCodeInput,
  PaymentTermSelect,
  GLMainAccountSelect
} from "../inputs";

const CustomerForm = ({ inputs, onChange, codeStates }) => (
  <React.Fragment>
    <Field className="grid-override is-four" kind="group">
      <Field kind="group" style={{ gridColumn: "span 2" }}>
        <Control expanded style={{ marginRight: "0.75rem" }}>
          <Label>Name</Label>
          <Input
            autoFocus
            required
            autocomplete="new"
            name="Name"
            tabIndex="1"
            type="text"
            value={inputs.Name}
            onChange={onChange}
          />
        </Control>
        <Field kind="group" style={{ justifyContent: "flex-end" }}>
          <Control>
            <Label>Bill To</Label>
            <BooleanInput
              name="BillToCust"
              value={inputs.BillToCust}
              onChange={onChange}
            />
          </Control>
          <Control>
            <Label>Order</Label>
            <BooleanInput
              name="OrderCust"
              value={inputs.OrderCust}
              onChange={onChange}
            />
          </Control>
          <Control>
            <Label>Active</Label>
            <BooleanInput
              name="Active"
              value={inputs.Active}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Field>
      <Control expanded>
        <SystemCodeSelect
          icon="globe"
          label="Customer Group"
          lookup={{ Category: "Customer", Code: "CustomerType" }}
          name="CustomerTypeRecIdRef"
          value={inputs.CustomerTypeRecIdRef}
          onChange={onChange}
        />
      </Control>
      {inputs?.BillToCust && (
        <Control expanded>
          <PaymentTermSelect
            required
            label="Payment Term"
            name="PaymentTermsRecIdRef"
            value={inputs?.PaymentTermsRecIdRef}
            where={{ Active: true }}
            onChange={onChange}
          />
        </Control>
      )}
    </Field>
    <Field className="grid-override" kind="group">
      <Control expanded>
        <Label>Address 1</Label>
        <Input
          autocomplete="new"
          name="Address1"
          tabIndex="4"
          type="text"
          value={inputs.Address1}
          onChange={onChange}
        />
      </Control>
      <Control expanded>
        <Label>Billing Contact</Label>
        <Input
          autocomplete="new"
          name="BillingContactName"
          tabIndex="9"
          type="text"
          value={inputs.BillingContactName}
          onChange={onChange}
        />
      </Control>
    </Field>

    <Field className="grid-override" kind="group">
      <Control expanded>
        <Label>Address 2</Label>
        <Input
          autocomplete="new"
          name="Address2"
          tabIndex="5"
          type="text"
          value={inputs.Address2}
          onChange={onChange}
        />
      </Control>
      <Field className="grid-override" kind="group">
        <Control expanded>
          <Label>Phone #</Label>
          <PhoneNumberInput
            name="Telephone"
            tabIndex="10"
            value={inputs.Telephone}
            onChange={onChange}
          />
        </Control>
        <Control expanded>
          <Label>Fax #</Label>
          <PhoneNumberInput
            name="FaxNo"
            tabIndex="11"
            value={inputs.FaxNo}
            onChange={onChange}
          />
        </Control>
      </Field>
    </Field>

    <Field className="grid-override" kind="group">
      <Field className="grid-override" kind="group">
        <Control expanded>
          <Label>City</Label>
          <Input
            autocomplete="new"
            name="City"
            tabIndex="6"
            type="text"
            value={inputs.City}
            onChange={onChange}
          />
        </Control>
        <Field className="grid-override" kind="group">
          <Control expanded>
            <Label>State</Label>
            <StateSelect
              name="State"
              tabIndex="7"
              value={inputs.State}
              onChange={onChange}
            />
          </Control>
          <Control expanded>
            <Label>Zip</Label>
            <ZipCodeInput
              autocomplete="new"
              name="Zip"
              tabIndex="8"
              type="text"
              value={inputs.Zip}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Field>
      <Control expanded>
        <GLMainAccountSelect
          label="Revenue GL Override"
          name="RevGLRecIdRef"
          tabIndex="12"
          value={inputs.RevGLRecIdRef}
          where={{
            TypeRecIdRef: codeStates.revenue.RecId
          }}
          onChange={onChange}
        />
      </Control>
    </Field>
    <Field className="grid-override" kind="group">
      <Control />
      <Control expanded>
        <GLMainAccountSelect
          label="AR GL Override"
          name="ArGLRecIdRef"
          tabIndex="13"
          value={inputs.ArGLRecIdRef}
          where={{
            TypeRecIdRef: codeStates.asset.RecId
          }}
          onChange={onChange}
        />
      </Control>
    </Field>
  </React.Fragment>
);
CustomerForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func,
  codeStates: PropTypes.object
};

CustomerForm.defaultProps = {
  inputs: {}
};
export default CustomerForm;
